// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-clock-icon .ui-clock-icon-minute {
  animation: icon--hands 2s infinite linear;
  transform-origin: 8px 8px;
}
.ui-clock-icon .ui-clock-icon-hour {
  animation: icon--hands 12s infinite linear;
  transform-origin: 8px 8px;
}
@keyframes icon--hands {
0% {
    --webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
100% {
    --webkit-transform: rotate(359deg);
    transform: rotate(359deg);
}
}`, "",{"version":3,"sources":["webpack://./../../../../packages/ui-components/src/components/icons/clock/clock.vue"],"names":[],"mappings":"AAGA;EAEE,yCAAA;EACA,yBAAA;AAFF;AAMA;EAEE,0CAAA;EACA,yBAAA;AAHF;AAkBA;AACI;IACA,gCAAA;IACA,uBAAA;AALF;AAOA;IACE,kCAAA;IACA,yBAAA;AALF;AACF","sourcesContent":["\n\n// minute hand!\n.ui-clock-icon .ui-clock-icon-minute {\n  -webkit-animation: icon--hands 2s infinite linear;\n  animation: icon--hands 2s infinite linear;\n  transform-origin: 8px 8px;\n}\n\n// hour hand\n.ui-clock-icon .ui-clock-icon-hour {\n  -webkit-animation: icon--hands 2s infinite linear;\n  animation: icon--hands 12s infinite linear;\n  transform-origin: 8px 8px;\n}\n\n@-webkit-keyframes icon--hands {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n\n@keyframes icon--hands {\n    0% {\n    --webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    --webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
